import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { Paths } from '../constants/paths';
import { ALL_REFERRERS } from '../constants/referrers';
import { useProductTypeSearchParams } from '../hooks/useProductTypeSearchParams';
import { jsx as _jsx } from "react/jsx-runtime";
const RouteReferrerContext = /*#__PURE__*/createContext(undefined);
export function RouteReferrerProvider({
  children,
  referrer: referrerValue
}) {
  const productTypes = useProductTypeSearchParams();
  const {
    path: currentPath
  } = useRouteMatch();
  const [referrer, setReferrer] = useState(() => {
    return ALL_REFERRERS.find(_referrer => {
      return referrerValue === _referrer.referrer;
    });
  });
  const [referrerPath, setReferrerPath] = useState(() => referrer ? currentPath : undefined);
  const clearReferrer = useCallback(() => {
    setReferrer(undefined);
    setReferrerPath(undefined);
  }, []);
  const referrerRouteMatch = useRouteMatch({
    path: referrerPath,
    exact: true
  });
  useEffect(() => {
    if (!(referrer !== null && referrer !== void 0 && referrer.productType)) return;
    if (referrerRouteMatch) return;
    switch (currentPath) {
      case Paths.LISTING_DETAILS:
        break;
      case Paths.SEARCH_RESULTS:
        {
          if (!productTypes.length || !productTypes.every(t => t === referrer.productType)) {
            clearReferrer();
          }
          break;
        }
      default:
        clearReferrer();
        break;
    }
  }, [clearReferrer, currentPath, productTypes, referrer, referrerRouteMatch]);
  return /*#__PURE__*/_jsx(RouteReferrerContext.Provider, {
    value: referrer && referrerRouteMatch ? referrer : undefined,
    children: children
  });
}
export function useRouteReferrer() {
  return useContext(RouteReferrerContext);
}